import PropTypes from "prop-types";
import React from "react";

const TranslationNoticeSystemMessage = ({ text }) => {
    return (
        <li className="system-message translation-notice">
            <p className="body">{text}</p>
        </li>
    );
};

TranslationNoticeSystemMessage.propTypes = {
    text: PropTypes.string.isRequired,
};

export default TranslationNoticeSystemMessage;
